import React /*, { useEffect }*/ from 'react';
import { /*useDispatch,*/ useSelector } from 'react-redux';
import { STATUS, /*loadPlataformas,*/ selectPlataforma } from './plataformaSlice';
import Spinner from '../../components/Spinner';
import EditarResponsable from './EditarResponsablePlataforma';
//import { plataformas } from '../../app/utils';
//import { Link } from 'react-router-dom';
import './ListaPlataformas.css';

export default function ListaPlataformas () {
    const { results, status, error } = useSelector(selectPlataforma);
    //const dispatch = useDispatch();

    /* useEffect(() => {
        loadList();
    }, []);

    function loadList(){
        dispatch(loadPlataformas());
    } */
        
    // eslint-disable-next-line no-unused-vars
    function onClickHandler({target}) {
        
    }

    if (status === STATUS.LOADING) {
        return <Spinner/>;
    }

    if (error === STATUS.COULDNT_LOAD) {
        return (
            <div className='search-results'>
                <p>No se pudo completar la carga.</p>
            </div>
        );
    }

    if (status === STATUS.NO_DATA) {
        return;
    }

    return (
        <>
            <div className='search-results'> 
                <div className="user-results">
                    <div className="table-container">
                        <div className="table-row header">
                            <div className="table-cell">Plataforma</div>
                            <div className="table-cell">E-mail</div>
                            <div className="table-cell"></div>
                        </div>
                        {results.map((plataforma, i) => (
                            <div key={i} className="table-row">
                                <div className="table-cell">{plataforma.nombre}</div>
                                <div className="table-cell">{plataforma.responsable}
                                    {/*<Link to={`/usuario/${plataforma.responsable}`}>{plataforma.responsable}</Link>*/}
                                </div>
                                <div className="table-cell"><EditarResponsable plataforma={plataforma.nombre}/></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            
        </>
    );
    
}